import { z } from "zod";

export const trackSchema = z.object({
  duration: z.number(),
  guide_ids: z.number().array().optional(),
  has_access: z.boolean().optional(),
  has_transcript: z.boolean().optional(),
  id: z.number(),
  length: z.string(),
  media_type: z.enum(["audio", "video"]),
  paid: z.boolean(),
  prayer_id: z.number(),
});

export type Track = z.infer<typeof trackSchema>;
